import React from 'react';
import { css } from 'styled-components'
import PropTypes from 'prop-types';
import { FormSearch } from 'grommet-icons';
import adapter from '@flopflip/memory-adapter';
import { ToggleFeature, ConfigureFlopFlip } from '@flopflip/react-broadcast';
import CreateableSelect from 'react-select/creatable'
import flags from 'components/common/flopflip-flags'

import {
  Box,
  TextInput,
  Button,
  Heading,
  RadioButtonGroup,
  Select,
  RangeInput,
  Grommet
} from 'grommet';
import { Erase, Save } from 'grommet-icons'

import FormSection from './ui/FormSection'
import { cities } from './cities'


const textInputTheme = {
  textInput: {
    extend: css`
      ${props => 'width: 100%; border: none; padding-top: 13px;' } 
    `
  },
  box: {
    extend: css`
      ${props => 'flex-direction: row; margin-bottom: 9px; border: 1px solid rgba(0,0,0,0.33);' } 
    `
  }

};

const mapCompTypeToDisplay = (ct) => {
    return ct && ct == 'hourly' ? 'hourly rate' : ct === 'yearly' ? 'yearly salary' : 'fixed price'
}

const mapDisplayToCompType = (units) => {
    return units === 'hourly rate' ? 'hourly' : units === 'yearly salary' ? 'yearly' : 'fixed'
}

const mapCompAndAmount = (compType, amount) => {
   return compType === 'yearly' ?
       `comp ${amount}k a year` :
            compType === 'hourly' ?
                `comp ${amount} per hour` :
                `comp ${amount}`
}

const mapCompRange = (compType) => {
    switch (compType) {
        case 'hourly':
        case 'yearly':
            return [0 , 100, 1]
        case 'fixed':
            return [0, 10000, 100]
        default:
            return [0, 100, 1]
    }
}

// TODO Factor this into components

const Filters = props => {
    console.log(props)
  const {
      options,
      setOption,
      reset,
      search,
      saveSearch,
      addSearch,
      deleteSearch,
      loadSearch,
      savedSearchOptions,
      savedSearchName,
      savedSearchLoading
    } = props;
  const { city, distance, compensation, compensationType, keywords } = options;
  const [cmin, cmax, cstep] = mapCompRange(compensationType)
    const searchNameValue = (savedSearchName && savedSearchName !== '')
        ? { label: savedSearchName, value: savedSearchName }
        : null

    return (
      <Box>
          <FormSection>
              <Box direction="row">
              <Box fill="horizontal">
                  <CreateableSelect
                    options={savedSearchOptions}
                    value={searchNameValue}
                    isDisabled={savedSearchLoading}
                    isLoading={savedSearchLoading}
                    onChange={loadSearch}
                    onCreateOption={addSearch}
                  />
             </Box>
             <Box direction="column">
               <Save onClick={saveSearch} disabled={searchNameValue == null}/>
               <Erase onClick={deleteSearch}/>
             </Box>
              </Box>
          </FormSection>
        <FormSection>
          <Grommet theme={textInputTheme}>
            <Box>
              <FormSearch size="large" />
              <TextInput
                placeholder="must include these terms"
                value={keywords}
                onChange={event => { console.log(event.target); setOption('keywords', event.target.value)}}
                plain={true} 
                focusIndicator={false} 
              />
            </Box>
            <ConfigureFlopFlip defaultFlags={flags} adapter={adapter}>  
              <ToggleFeature flag={'logicalOperatorsInGigsSearch'}>
                <> 
                <Box>
                  <FormSearch size="large" />
                  <TextInput plain={true} focusIndicator={false} placeholder="could include these terms" />
                </Box>
                <Box>
                  <FormSearch size="large" />
                  <TextInput plain={true} focusIndicator={false} placeholder="exclude these terms" />
                </Box>
                </>
              </ToggleFeature>
            </ConfigureFlopFlip>
          </Grommet>
          <Box
            direction="row"
            justify="between"
            pad={{'vertical': '15px'}}
          >
            <Button
              label="reset filters"
              onClick={reset}
            />
            <Button
              label="filter gigs"
              onClick={search}
              primary={true}
            />
          </Box>
        </FormSection>
        <FormSection heading="LOCATION">
            <Box pad={{'vertical': '10px'}}>
              <Select
                options={['Current city'].concat(cities)}
                value={city === '' ? 'Current city' : city}
                onChange={({ option }) => setOption('city', option === 'Current city' ? '' : option)}
                margin={{'vertical': '10px'}}
              />
            </Box>
            <ConfigureFlopFlip defaultFlags={flags} adapter={adapter}>  
              <ToggleFeature flag={'distance'}>
                <Box pad={{'bottom': '10px'}}>
                  <Heading margin='none' level="5">distance {distance} miles</Heading>
                  <RangeInput
                    value={distance}
                    onChange={event => setOption('distance', event.target.value)}
                  />
                </Box>
              </ToggleFeature>
            </ConfigureFlopFlip>

        </FormSection>
        <FormSection heading="MINIMUM COMPENSATION">
            <Box pad={{'vertical': '10px'}}>
              <RadioButtonGroup
                name="doc"
                options={['hourly rate', 'yearly salary', 'fixed price']}
                value={mapCompTypeToDisplay(compensationType)}
                onChange={(ev) => { setOption('compensationType', mapDisplayToCompType(ev.target.value)) }}
              />
              <Box pad={{'top': '7px', 'bottom': '10px'}}>
                <Heading margin='none' level="5">
                  { mapCompAndAmount(compensationType, compensation)}
                </Heading>
                <RangeInput
                    min={cmin}
                    max={cmax}
                    step={cstep}
                  value={compensation}
                  onChange={event => setOption('compensation', event.target.value)}
                />
              </Box>
            </Box>
        </FormSection>
      </Box>
      );
}

// Filters.propTypes = {
//   classes: PropTypes.object.isRequired,
//   setOptions: PropTypes.func.isRequired
// }

export default Filters